
export function cep(value = "", previousValue?: any) {
  let formattedValue = value;
  if (value.length > 9) {
    formattedValue = value.substring(0, 9)
  }
  formattedValue = formattedValue.replace(/\D/g, "");
  formattedValue = formattedValue.replace(/^(\d{5})(\d)/, "$1-$2");
  return formattedValue;
}


export function percentage(value: any, previousValue?: any): string {
  const LANGUAGE = 'pt-BR';

  //@TODO internacionalizar

  let formattedValue = (value == "") ? "0,00" : String(value);

  const previousValueWasAlreadyFormatted = previousValue?.includes(",");

  if (!formattedValue.includes(",") && !previousValueWasAlreadyFormatted) {
    return (new Intl.NumberFormat(LANGUAGE, { style: 'decimal', minimumFractionDigits: 2 })).format(value * 100)
  }


  formattedValue = formattedValue.replace(/[\.\,]/g, '');
  const parsedValue = Number(formattedValue) / 100;

  formattedValue = (new Intl.NumberFormat(LANGUAGE, { style: 'decimal', minimumFractionDigits: 2 })).format(parsedValue)

  return formattedValue;
}


export function currency(value: any, previousValue?: any): string {
  const LANGUAGE = 'pt-BR';

  //@TODO internacionalizar

  let formattedValue = (value == "") ? "0,00" : String(value);

  const previousValueWasAlreadyFormatted = previousValue?.includes(",");

  if (!formattedValue.includes(",") && !previousValueWasAlreadyFormatted) {
    return (new Intl.NumberFormat(LANGUAGE, { style: 'decimal', minimumFractionDigits: 2 })).format(value)
  }


  formattedValue = formattedValue.replace(/[\.\,]/g, '');
  const parsedValue = Number(formattedValue) / 100;

  formattedValue = (new Intl.NumberFormat(LANGUAGE, { style: 'decimal', minimumFractionDigits: 2 })).format(parsedValue)

  return formattedValue;
}

export function removeCurrencyMask(value: string, previousValue?: any) {
  return parseFloat(value.replace(/\./g, "").replace(/,/g, "."))
}

export function cpf(value = "") {
  let formattedValue = value;
  if (value.length > 14) {
    formattedValue = value.substring(0, 14)
  }
  if (!formattedValue.match(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})$/)) {
    formattedValue = formattedValue.replace(/\D/g, "");
    formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
    formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
    formattedValue = formattedValue.replace(/(\d{3})(\d{2})$/, "$1-$2");
  }
  return formattedValue;
}



export function convertFloatToMonetary(value = 0.00) {
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 });

}





